import { Component } from '@angular/core';
import {  OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../../service/root.service';

import { Project } from '../shared/project';
import { ProjectService } from '../shared/project.service';

import {ConfirmationService} from 'primeng/primeng';

@Component({

    selector: 'project-crud',
    templateUrl: './project-crud.component.html',
    styleUrls: ['./project-crud.component.scss']
})
export class ProjectCrudComponent implements OnInit, OnDestroy {
    @Input() project: Project;
    @Input() id: number;
    @Input() operation: string;
    
  
  
    fromRoute: boolean;

    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;


    constructor(public rootService: RootService,
        public projectService: ProjectService,
        public route: ActivatedRoute,
        public router: Router,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) {

        var routeData = this.route.snapshot.data;
        if( routeData['page'] && ((routeData['page']).split("."))[1] == "project"){
            this.fromRoute = routeData['fromRoute'];
            this.operation = routeData['operation'];
        }


    }
    ngOnChanges() {

    }
    update() {
        this.operation ='update';
    }
    back(event){
        if(event != 'update'){
            this.router.navigate(['admin/project']);
        }
        
    }
    
    ngOnInit() {
        if (this.fromRoute) {
            if (this.operation == 'create') {
                this.id=null;
            } else {
                this.routeEvent = this.router.events.subscribe((val) => {
                    if (val instanceof NavigationEnd) {
                        this.route.params.subscribe(params => {
                            this.id = +params['id']; // (+) converts string 'id' to a number
                        });
                    }
                });
            }
        }

    }
    ngOnDestroy() {

    }
}



// WEBPACK FOOTER //
// ./src/app/module/project/project-crud/project-crud.component.ts